
// import Vue from 'vue'

export const HeaderGral = () => {
  const token = localStorage.getItem('token_pv') // Vue.$cookies.get('token_pv')
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  return headers
}
export const HeaderFileGral = () => {
  const token = localStorage.getItem('token_pv') // Vue.$cookies.get('token_pv')
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
      responseType: 'blob'
    }
  }
  return headers
}
export const HeaderFileBoundaryGral = (boundary) => {
  const token = localStorage.getItem('token_pv') // Vue.$cookies.get('token_pv')
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data' + boundary
    }
  }
  return headers
}
export const UserSession = () => {
  const user = JSON.parse(localStorage.getItem('user_pv')) // Vue.$cookies.get('user_pv')
  return user
}
export const Token = () => {
  const token = localStorage.getItem('token_pv') // Vue.$cookies.get('token_pv')
  return token
}
